export default [
  {
    path: "/",
    redirect: "/wlogin",
  },
  {
    path: "/wlogin",
    name: "wlogin",
    component: () => import("@/views/WLogin.vue"),
  },
  {
    path: "/nestinfo",
    name: "nestinfo",
    component: () => import("@/views/NestInfo"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/commitinfo",
    name: "commitinfo",
    component: () => import("@/views/CommitInfo"),
    meta: {
      keepAlive: true,
    },
  },
  // {
  //   path: "/selectway",
  //   name: "selectway",
  //   component: () => import("@/views/WeixinSelect"),
  // },
  // {
  //   path: "/phone",
  //   name: "phone",
  //   component: () => import("@/views/Phone"),
  // },
  {
    path: "/shareExcellent",
    name: "shareExcellent",
    component: () => import("@/views/ShareExcellent"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/antfree",
    name: "antfree",
    component: () => import("@/views/AntFree"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/antpay",
    name: "antpay",
    component: () => import("@/views/AntPay"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/antinhome",
    name: "antinhome",
    component: () => import("@/views/AntInHome"),
    meta: {
      keepAlive: true
    },
  },
  // PayCommitInfo
  {
    path: "/antcommitinfo",
    name: "antcommitinfo",
    component: () => import("@/views/AntCommitInfo"),
    meta: {
      keepAlive: true,
    },
  },
  // AnswerCommitinfo
  {
    path: "/antanswercommintinfo",
    name: "antanswercommintinfo",
    component: () => import("@/views/AntAnswerCommitinfo"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/campcommitinfo",
    name: "campcommitinfo",
    component: () => import("@/views/Campcommitinfo"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/antinvite",
    name: "antinvite",
    component: () => import("@/views/Antinvite"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/readpackage",
    name: "readpackage",
    component: () => import("@/views/ReadPackage"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/goodtask",
    name: "goodtask",
    component: () => import("@/views/GoodTask"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/book",
    name: "book",
    component: () => import("@/views/Book"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/bookshelf",
    name: "bookshelf",
    component: () => import("@/views/BookShelf"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/userbookshelf",
    name: "bookshelf",
    component: () => import("@/views/UserBookShelf"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/excellentinvite",
    name: "excellentinvite",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/Excellentinvite"),
  },
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: () => import("@/views/CourseDetail"),
  },
  // 训练营免费邀请阶段
  {
    path: "/camppayfree",
    name: "camppayfree",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/CampPayfree"),
  },
  // 训练营开营阶段
  {
    path: "/campindex",
    name: "campindex",
    component: () => import("@/views/Campindex"),
  },
  // 训练营预售阶段
  {
    path: "/camppay",
    name: "camppay",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/CampPay"),
  },
  {
    path: "/feepannel",
    name: "freepannel",
    component: () => import("@/views/Freepannel"),
  },
  // 周年庆活动页面哈；
  {
    path: "/anniversary",
    name: "anniversary",
    component: () => import("@/views/Anniversary"),
    meta: {
      keepAlive: true,
    },
  },
  // H5 周年庆的时候领取成功的时候
  // {
  //   path: "/anresult",
  //   name: "anresult",
  //   component: () => import("@/views/AnResult"),
  // },
  {
    path: "/coupon",
    name: "coupon",
    component: () => import("@/views/CouponPay"),
    meta: {
      keepAlive: true,
    },
  },
];
